import nl from './nl';
import de from './de';
import en from './en';

export const defaultLocale = 'nl';

export const languages = {
  nl, de, en
};
